import { render, staticRenderFns } from "./teacher-home.vue?vue&type=template&id=3b6319c1&scoped=true"
import script from "./teacher-home.vue?vue&type=script&lang=js"
export * from "./teacher-home.vue?vue&type=script&lang=js"
import style0 from "./teacher-home.vue?vue&type=style&index=0&id=3b6319c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6319c1",
  null
  
)

export default component.exports